import {GAME_DEBUG_MODE} from "../../engine/Constants/Constants";

export class HospitalIDMapper {
    public static idToStringObject: Record<string, string> = null;

    public static isInitialized: boolean = false;
    // public static treatmentsToSymptoms: Record<string, string[]> = null;
    // public static examsToSymptoms: Record<string, string[]> = null;
    // public static symptomsToTreatments: Record<string, string[]> = null;
    // public static symptomsToDiagnoses: Record<string, string[]> = null;
    // public static diagnosesToSymptoms: Record<string, string[]> = null;
    // public static diagnosisToExaminations: Record<string, string> = null;

    private static mapMap: Record<string, {
        data: Record<string, string[] | string>;
        path: string;
    }> = {
        treatmentsToSymptoms: {
            path: "./assets/data/TreatmentsToSymptoms.json",
            data: null
        },
        examsToSymptoms: {
            path: "./assets/data/ExamsToSymptoms.json",
            data: null
        },
        symptomsToExaminations: {
            path: "./assets/data/SymptomsToExaminations.json",
            data: null
        },
        symptomsToTreatments: {
            path: "./assets/data/SymptomsToTreatments.json",
            data: null
        },
        symptomsToDiagnoses: {
            path: "./assets/data/SymptomsToDiagnoses.json",
            data: null
        },
        diagnosesToSymptoms: {
            path: "./assets/data/DiagnosesToSymptoms.json",
            data: null
        },
        diagnosisToExaminations: {
            path: "./assets/data/DiagnosisToExaminations.json",
            data: null
        },
    };

    public static getString(_key: string, _id: string): string[] {
        const val = HospitalIDMapper.mapMap[_key]?.data[_id];
        if(!val) {
            console.error("Failed to find %s in %s!", _id, _key);
            return [];
        }
        return typeof val === "string" ? [val] : [...val];
    }

    public static initialize(): Promise<void> {
        if(HospitalIDMapper.isInitialized) return;

        const promises: Promise<void>[] = [];
        if(GAME_DEBUG_MODE) console.log("Initializing HospitalIDMapper...");

        Object.keys(HospitalIDMapper.mapMap)
            .forEach((e) => {
                const currPath = HospitalIDMapper.mapMap[e].path;
                const promise = fetch(currPath)
                    .then((data) => {
                        return data.json();
                    })
                    .then((data: Record<string, string[]>) => {
                        HospitalIDMapper.mapMap[e].data = data;
                    });
                promises.push(promise);
            });

        promises.push(new Promise<void>((res, rej) => {
            fetch("./assets/data/idToString.json")
                .then((data) => {
                    return data.json();
                })
                .catch((err) => rej(err))
                .then((data: Record<string, string>) => {
                    HospitalIDMapper.idToStringObject = data;
                })
                .then(() => res());
        }));

        return Promise.allSettled(promises).then(() => {
            HospitalIDMapper.isInitialized = true;
            if(GAME_DEBUG_MODE) console.log("Initialized HospitalIDMapper");
        });
    }
}